module.exports = __webpack_public_path__ + "img/login-art-1.5030ee3.jpg";